<div class="mt-3 p-3">
  <div class="page-title d-flex justify-content-between align-items-center mb-3">
      <h4>Amenity Categories</h4>
      <p-button
        pButton
        type="button"
        label="Create Amenity Category"
        icon="pi pi-plus"
        class="primary-btn"
        (click)="showDialog('right')"
      ></p-button>
    </div>
    
    <div class="amenity-categories p-4">
      <h6 class="fw-normal mb-3">Amenity Categories Listing</h6>
      <p-table [value]="amenityCategories" responsiveLayout="scroll" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-category>
          <tr>
            <td>{{ category.name }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
</div>
<p-dialog header="Create Amenity Category" [modal]="true" [(visible)]="visible" [position]="position" [style]="{ width: '35%' }" draggable="false">
  <app-create-amenity-category></app-create-amenity-category>
</p-dialog>